import { Image } from 'semantic-ui-react';
import './Logo.less';
interface LogoProps {
	sticky?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ sticky }) => {
	const cls = 'logo' + (sticky ? ' sticky' : '');
	return <Image className={cls} src={process.env.PUBLIC_URL + '/logo.png'} />;
};
